module.exports = __webpack_public_path__ + "images/Stock_Officers.png";